import React from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { Button } from '../components/ui/button';
import { ArrowRight, ArrowLeft, CheckCircle, X, HelpCircle, MessageCircle, Mail, Zap } from 'lucide-react';


import Navbar from '../components/Navbar';

const Planos = () => {
  const navigate = useNavigate();

  // Função para lidar com upgrade PRO
  const handleUpgradePro = () => {
    const token = localStorage.getItem('lembrou_token');
    
    if (token) {
      // Usuário já logado - redireciona para o perfil (aba assinatura)
      navigate('/perfil?tab=assinatura');
    } else {
      // Usuário não logado - redireciona para cadastro com parâmetro upgrade=pro
      navigate('/auth?mode=business&upgrade=pro');
    }
  };

  const planos = [
    {
      nome: 'Essencial',
      preco: '0',
      periodo: '/mês',
      descricao: 'Perfeito para começar',
      destaque: false,
      recursos: [
        { texto: 'Até 20 contratos ativos', incluido: true },
        { texto: 'Alertas por e-mail', incluido: true },
        { texto: 'Painel de controle', incluido: true },
        { texto: 'QR Code por cliente', incluido: true },
        { texto: 'Alertas por WhatsApp automáticos', incluido: true },
        { texto: 'Envio manual de WhatsApp', incluido: false },
        { texto: 'Importação CSV/PDF', incluido: false },
        { texto: 'Suporte prioritário', incluido: false },
      ],
      botao: 'Começar Grátis',
      acao: () => navigate('/auth?mode=business'),
      disabled: false,
    },
    {
      nome: 'Profissional',
      preco: '19',
      centavos: ',99',
      periodo: '/mês',
      descricao: 'O mais escolhido',
      destaque: true,
      recursos: [
        { texto: 'Contratos ilimitados', incluido: true },
        { texto: 'Alertas por e-mail', incluido: true },
        { texto: 'Alertas por WhatsApp automáticos', incluido: true },
        { texto: 'Envio manual de WhatsApp', incluido: true },
        { texto: 'Painel de controle', incluido: true },
        { texto: 'QR Code por cliente', incluido: true },
        { texto: 'Importação CSV/PDF', incluido: true },
        { texto: 'Suporte prioritário', incluido: false },
      ],
      botao: 'Assinar Agora',
      acao: handleUpgradePro,
      disabled: false,
    },
    {
      nome: 'Premium',
      preco: '59',
      centavos: ',99',
      periodo: '/mês',
      descricao: 'Para grandes operações',
      destaque: false,
      recursos: [
        { texto: 'Tudo do Profissional', incluido: true },
        { texto: 'Marca personalizada', incluido: true },
        { texto: 'Painel de histórico', incluido: true },
        { texto: 'Relatórios avançados', incluido: true },
        { texto: 'API de integração', incluido: true },
        { texto: 'Suporte prioritário', incluido: true },
        { texto: 'Gerente de conta', incluido: true },
      ],
      botao: 'Em Breve',
      acao: () => {},
      disabled: true,
    },
  ];

  const comparativo = [
    { recurso: 'Contratos ativos', essencial: 'Até 20', profissional: 'Ilimitados', premium: 'Ilimitados' },
    { recurso: 'Alertas por e-mail', essencial: true, profissional: true, premium: true },
    { recurso: 'WhatsApp automático', essencial: true, profissional: true, premium: true },
    { recurso: 'WhatsApp manual (avulso)', essencial: false, profissional: true, premium: true },
    { recurso: 'QR Code por cliente', essencial: true, profissional: true, premium: true },
    { recurso: 'Importação CSV/PDF', essencial: false, profissional: true, premium: true },
    { recurso: 'Marca personalizada', essencial: false, profissional: false, premium: true },
    { recurso: 'Relatórios avançados', essencial: false, profissional: false, premium: true },
    { recurso: 'API de integração', essencial: false, profissional: false, premium: true },
    { recurso: 'Suporte prioritário', essencial: false, profissional: false, premium: true },
  ];

  return (
    <div className="min-h-screen bg-white">
      {/* ===== NAVBAR ===== */}
	  {/* ============================================================
           PASSO 2 — Substitua qualquer <nav> antiga por este componente
           Basta colocar <Navbar /> no topo de cada página.
           O link ativo é detectado automaticamente pela URL.
          ============================================================ */}
      <Navbar />
	  

      {/* ===== HERO ===== */}
      <section className="relative overflow-hidden bg-gradient-to-br from-white via-red-50/30 to-white py-16 lg:py-24">
        <div className="absolute top-20 right-0 w-[500px] h-[500px] bg-primary/5 rounded-full blur-3xl -z-10" />
        
        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
         

          <div className="text-center max-w-3xl mx-auto">
            <span className="inline-block bg-primary/10 text-primary text-sm font-semibold px-4 py-1.5 rounded-full mb-6">
              Planos e Preços
            </span>
            <h1 className="text-4xl sm:text-5xl font-extrabold text-gray-900 leading-tight mb-6">
              Transparência total em nossos <span className="text-primary">preços</span>
            </h1>
            <p className="text-lg text-gray-500 leading-relaxed">
              Escolha o plano que faz sentido para o seu negócio. 
              Sem surpresas, sem letras miúdas.
            </p>
          </div>
        </div>
      </section>

      {/* ===== PLANOS ===== */}
      <section className="py-20 bg-gray-50">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid md:grid-cols-3 gap-6 max-w-5xl mx-auto">
            {planos.map((plano, index) => (
              <div
                key={index}
                className={`rounded-2xl p-8 relative transition-all ${
                  plano.destaque
                    ? 'bg-gray-900 text-white shadow-xl scale-105 z-10'
                    : 'bg-white border-2 border-gray-100 hover:border-primary/30 hover:shadow-lg'
                }`}
              >
                {plano.destaque && (
                  <div className="absolute -top-3 left-1/2 -translate-x-1/2 bg-primary text-white text-xs font-bold px-4 py-1 rounded-full">
                    Popular
                  </div>
                )}

                <p className={`text-sm font-bold uppercase tracking-wider mb-2 ${plano.destaque ? 'text-gray-400' : 'text-gray-400'}`}>
                  {plano.nome}
                </p>
                <p className={`text-sm mb-4 ${plano.destaque ? 'text-gray-400' : 'text-gray-500'}`}>
                  {plano.descricao}
                </p>

                <div className="flex items-baseline gap-1 mb-6">
                  <span className="text-sm">R$</span>
                  <span className={`text-5xl font-extrabold ${plano.destaque ? 'text-white' : 'text-gray-900'}`}>
                    {plano.preco}
                  </span>
                  {plano.centavos && (
                    <span className={`text-lg font-bold ${plano.destaque ? 'text-gray-400' : 'text-gray-400'}`}>
                      {plano.centavos}
                    </span>
                  )}
                  <span className={`text-sm ${plano.destaque ? 'text-gray-400' : 'text-gray-400'}`}>
                    {plano.periodo}
                  </span>
                </div>

                <ul className="space-y-3 mb-8">
                  {plano.recursos.map((recurso, i) => (
                    <li key={i} className={`flex items-center gap-2 text-sm ${
                      plano.destaque 
                        ? recurso.incluido ? 'text-gray-300' : 'text-gray-600 line-through' 
                        : recurso.incluido ? 'text-gray-600' : 'text-gray-400 line-through'
                    }`}>
                      {recurso.incluido ? (
                        <CheckCircle className="w-4 h-4 text-primary flex-shrink-0" />
                      ) : (
                        <X className={`w-4 h-4 flex-shrink-0 ${plano.destaque ? 'text-gray-600' : 'text-gray-300'}`} />
                      )}
                      {recurso.texto}
                    </li>
                  ))}
                </ul>

                <Button
                  onClick={plano.acao}
                  disabled={plano.disabled}
                  className={`w-full rounded-xl py-5 font-semibold ${
                    plano.destaque
                      ? 'bg-primary hover:bg-primary-hover text-white'
                      : plano.disabled
                        ? 'bg-gray-100 text-gray-400 cursor-not-allowed'
                        : 'bg-primary hover:bg-primary-hover text-white'
                  }`}
                >
                  {plano.botao}
                </Button>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ===== COMPARATIVO ===== */}
      <section className="py-20 bg-white">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-3xl font-bold text-gray-900 mb-4">Comparativo completo</h2>
            <p className="text-gray-500">Veja todas as diferenças entre os planos</p>
          </div>

          <div className="overflow-x-auto">
            <table className="w-full max-w-4xl mx-auto">
              <thead>
                <tr className="border-b border-gray-200">
                  <th className="text-left py-4 px-4 font-semibold text-gray-900">Recurso</th>
                  <th className="text-center py-4 px-4 font-semibold text-gray-900">Essencial</th>
                  <th className="text-center py-4 px-4 font-semibold text-primary">Profissional</th>
                  <th className="text-center py-4 px-4 font-semibold text-gray-900">Premium</th>
                </tr>
              </thead>
              <tbody>
                {comparativo.map((item, index) => (
                  <tr key={index} className="border-b border-gray-100">
                    <td className="py-4 px-4 text-gray-600">{item.recurso}</td>
                    <td className="py-4 px-4 text-center">
                      {typeof item.essencial === 'boolean' ? (
                        item.essencial ? (
                          <CheckCircle className="w-5 h-5 text-green-500 mx-auto" />
                        ) : (
                          <X className="w-5 h-5 text-gray-300 mx-auto" />
                        )
                      ) : (
                        <span className="text-gray-600">{item.essencial}</span>
                      )}
                    </td>
                    <td className="py-4 px-4 text-center bg-primary/5">
                      {typeof item.profissional === 'boolean' ? (
                        item.profissional ? (
                          <CheckCircle className="w-5 h-5 text-green-500 mx-auto" />
                        ) : (
                          <X className="w-5 h-5 text-gray-300 mx-auto" />
                        )
                      ) : (
                        <span className="text-primary font-medium">{item.profissional}</span>
                      )}
                    </td>
                    <td className="py-4 px-4 text-center">
                      {typeof item.premium === 'boolean' ? (
                        item.premium ? (
                          <CheckCircle className="w-5 h-5 text-green-500 mx-auto" />
                        ) : (
                          <X className="w-5 h-5 text-gray-300 mx-auto" />
                        )
                      ) : (
                        <span className="text-gray-600">{item.premium}</span>
                      )}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </section>

      {/* ===== FAQ RÁPIDO ===== */}
      <section className="py-20 bg-gray-50">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-3xl font-bold text-gray-900 mb-4">Dúvidas frequentes</h2>
          </div>

          <div className="space-y-4">
            {[
              { q: 'Posso mudar de plano a qualquer momento?', a: 'Sim! Você pode fazer upgrade ou downgrade a qualquer momento. A mudança é aplicada imediatamente.' },
              { q: 'Como funciona o período de teste?', a: 'O plano Essencial é gratuito para sempre. Você pode testar e depois fazer upgrade quando quiser.' },
              { q: 'Quais formas de pagamento são aceitas?', a: 'Aceitamos cartões de crédito (Visa, Mastercard, Amex) através do Stripe, a plataforma de pagamentos mais segura do mundo.' },
              { q: 'Posso cancelar a assinatura?', a: 'Sim, você pode cancelar a qualquer momento. Sua assinatura permanece ativa até o final do período pago.' },
            ].map((item, i) => (
              <div key={i} className="bg-white rounded-xl p-6 border border-gray-100">
                <h3 className="font-semibold text-gray-900 mb-2 flex items-center gap-2">
                  <HelpCircle className="w-5 h-5 text-primary" />
                  {item.q}
                </h3>
                <p className="text-gray-500 pl-7">{item.a}</p>
              </div>
            ))}
          </div>

          <div className="text-center mt-8">
            <Link to="/faq" className="text-primary font-medium hover:underline inline-flex items-center gap-1">
              Ver todas as perguntas
              <ArrowRight className="w-4 h-4" />
            </Link>
          </div>
        </div>
      </section>

      {/* ===== CTA ===== */}
      <section className="py-20 bg-primary">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <Zap className="w-12 h-12 text-white/80 mx-auto mb-6" />
          <h2 className="text-3xl sm:text-4xl font-bold text-white mb-6">
            Comece gratuitamente agora
          </h2>
          <p className="text-white/80 mb-8 text-lg">
            Sem cartão de crédito. Sem compromisso. Cancele quando quiser.
          </p>
          <Button
            onClick={() => navigate('/auth?mode=business')}
            className="rounded-full bg-white text-primary hover:bg-gray-100 px-8 py-6 text-base font-semibold shadow-lg"
          >
            Criar Conta Grátis
            <ArrowRight className="w-4 h-4 ml-2" />
          </Button>
        </div>
      </section>

      {/* ===== FOOTER ===== */}
      <footer className="bg-gray-900 text-white py-16">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid md:grid-cols-4 gap-10">
            <div>
              <img src="/lembrou-logo-png.png" alt="Lembrou?" className="h-8 mb-4 brightness-0 invert" />
              <p className="text-sm text-gray-400">
                2026 © Lembrou.com.br
                <br />Todos os direitos reservados.
              </p>
            </div>
            <div>
              <p className="font-semibold mb-4 text-sm">Central do Corretor</p>
              <ul className="space-y-2 text-sm text-gray-400">
                <li><button onClick={() => navigate('/auth?mode=business')} className="hover:text-white transition-colors">Cadastre-se</button></li>
                <li><button onClick={() => navigate('/auth?mode=business')} className="hover:text-white transition-colors">Login</button></li>
              </ul>
            </div>
            <div>
              <p className="font-semibold mb-4 text-sm">Institucional</p>
              <ul className="space-y-2 text-sm text-gray-400">
                <li><Link to="/sobre" className="hover:text-white transition-colors">Sobre o Lembrou?</Link></li>
                <li><Link to="/planos" className="hover:text-white transition-colors">Planos e Preços</Link></li>
                <li><Link to="/como-funciona" className="hover:text-white transition-colors">Como Funciona</Link></li>
                <li><Link to="/faq" className="hover:text-white transition-colors">FAQ</Link></li>
              </ul>
            </div>
            <div>
              <p className="font-semibold mb-4 text-sm">Usuário</p>
              <ul className="space-y-2 text-sm text-gray-400">
                <li><button onClick={() => navigate('/timeline')} className="hover:text-white transition-colors">Minha Timeline</button></li>
                <li><button onClick={() => navigate('/auth?mode=user')} className="hover:text-white transition-colors">Criar Conta Gratuita</button></li>
              </ul>
            </div>
          </div>
          <div className="border-t border-gray-800 mt-12 pt-8 text-center">
            <span className="text-xs text-gray-600">© 2026 Lembrou — Todos os direitos reservados</span>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default Planos;
